import React, { useEffect, useMemo, useState } from "react";
import AsyncSelect from "react-select/async";
import instance from "../../Interceptor/api_instance";
import debounce from "lodash.debounce";
import { customStyles } from "../Utility/ReactSelectStyles";
import { useTranslation } from "react-i18next";

const CHECK_OUT_CONDITIONS = ["good", "okay", "ready", "external-repair"];

const isCheckOutCondition = (condition) => {
  return CHECK_OUT_CONDITIONS.includes(condition);
};

const TruckOutSearchSelect = ({ onSelect, selectedTruck }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const filterOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 1) return [];

    try {
      const res = await instance.get(
        `assets/view-trucks?name=${inputValue}&q=${10}`
      );
      return res.data.map((truck) => ({
        ...truck.truck,
        value: truck.truck.id,
        label: isCheckOutCondition(truck.truck.truck_condition.toLowerCase())
          ? truck.truck.unit
          : `${truck.truck.unit} (${t(
              `forms.type.vehicle.select.truckCondition.${truck.truck.truck_condition.toLowerCase()}`
            )})`,
        isDisabled: !isCheckOutCondition(truck.truck.truck_condition.toLowerCase()),
      }));
    } catch (err) {
      console.error("Failed to fetch trucks: ", err);
      return [];
    }
  };

  useEffect(() => {
    setIsLoading(true);
    if (selectedTruck) filterOptions(selectedTruck.label);
    setIsLoading(false);
  }, []);

  // ✅ Debounce filterOptions and return a wrapped function that resolves a Promise
  const debouncedLoadOptions = useMemo(() => {
    const wrapped = debounce((inputValue, callback) => {
      filterOptions(inputValue).then(callback);
    }, 1000);
    return (inputValue) =>
      new Promise((resolve) => wrapped(inputValue, resolve));
  }, []);

  return (
    <AsyncSelect
      cacheOptions
      name="truck"
      inputId="truck-select"
      aria-label="Truck"
      value={selectedTruck}
      isLoading={isLoading}
      loadingMessage={() => t("general.loading")}
      defaultOptions={false}
      loadOptions={debouncedLoadOptions}
      onChange={(option) => onSelect(option)}
      placeholder={t("forms.type.vehicle.search.truck.search")}
      noOptionsMessage={() => t("forms.type.vehicle.search.truck.not-found")}
      isClearable
      className="search-select"
      styles={customStyles}
      unstyled={true}
      required
    />
  );
};

export default TruckOutSearchSelect;
